import * as React from 'react';
import { connect } from 'react-redux';
import { Selectors as Router } from 'router';
import { Selectors } from 'sections/client-management/services/sites';
import { State } from 'store';
import Prioritiser from './components/prioritiser';

export interface Props {
  clientLoaded: boolean;
}

export const Priorities: React.FC<Props> = (props: Props) => (props.clientLoaded ? <Prioritiser /> : null);

const mapState = (state: State): Props => ({
  clientLoaded: !!Selectors.getEntity(state, Router.getSiteId(state)),
});

export default connect(mapState)(Priorities);
